import { buttonConfig } from '@/constants/global';
// ui 권한 디렉티브
const uiPermission = {
    beforeMount: (el, { value, instance }) => {
        const store = instance?.$.appContext.config.globalProperties.$store;
        const isPermit = store.getters['user/getterUserPermission'](value);
        if (!isPermit) {
            // eslint-disable-next-line no-param-reassign
            el.style.display = 'none';
        }
    },
};
// v-btn 버튼 사이즈 디렉티브
// 예시) v-btn-style:config.primary.size-l.width-s
// class="brg-btn size-l width-s"
// https://qc-hub.barogo.io/design-system/button
const btnStyle = {
    // 후순 업데이트 버그 대응. 일단 beforeMount와 같게 추가, 추구 성능 개선시 확인 필요
    updated: (el, { modifiers }) => {
        const cssClass = [
            'brg-btn',
        ];
        Object.values(buttonConfig).forEach((config) => {
            config.some((styleType) => {
                if (modifiers[styleType]) {
                    cssClass.push(styleType);
                    return true;
                }
                return false;
            });
        });
        // outlined 여부
        if (modifiers.outlined) {
            cssClass.push('outlined');
        }
        el.classList.add(...cssClass);
    },
    beforeMount: (el, { modifiers }) => {
        const cssClass = [
            'brg-btn',
        ];
        Object.values(buttonConfig).forEach((config) => {
            config.some((styleType) => {
                if (modifiers[styleType]) {
                    cssClass.push(styleType);
                    return true;
                }
                return false;
            });
        });
        // outlined 여부
        if (modifiers.outlined) {
            cssClass.push('outlined');
        }
        el.classList.add(...cssClass);
    },
};
const trHighlightHook = (el, value, arg) => {
    const cssClass = arg === 'border'
        // 하이라이트를 border css로 이용하고 싶으면 border 타입.
        // 사용처 v-tr-highlight:border 로 검색하면 됨
        ? 'highlight-border-type'
        : 'highlight';
    if (value) {
        el.classList.add(cssClass);
        return;
    }
    el.classList.remove(cssClass);
};
/**
 * tr 클릭 아웃라인 디렉티브
 * <tr v-tr-highlight="boolean">
 * 운행설정, 배달대행료 참조
 */
const trHighlight = {
    updated: (el, { value, arg }) => {
        trHighlightHook(el, value, arg);
    },
    beforeMount: (el, { value, arg }) => {
        trHighlightHook(el, value, arg);
    },
};
/**
 * trHighlight에 필요한 데이터를 입력 받고 리턴 합니다.
 * 기준값 (고정)과 비교하여 boolean을 리턴합니다.
 * @param thisId 기준값
 * @param getSelectedId 비교값
 * @returns
 */
export const getTrHighlightValue = (thisId, getSelectedId) => () => thisId === getSelectedId();
const directives = {
    uiPermission,
    btnStyle,
    trHighlight,
};
export default {
    install(Vue) {
        Object.entries(directives).forEach(([key, value,]) => {
            Vue.directive(key, {
                ...value,
            });
        });
    },
};
